module.exports = __webpack_public_path__ + "static/img/s10.dd00741b.png";